<template>
  <div class="service-item w-col w-col-4 w-dyn-item">
    <div class="service-item-block w-clearfix">
      <img
        class="service-small-icon"
        src="https://daks2k3a4ib2z.cloudfront.net/562286e2281a128c5444df37/562373555ff4c43b472e9abd_Icon-iphone.png"
      >
      <router-link
        class="service-title"
        :to="{ name: 'ServiceDetail', params: {slug: service.slug}}"
      >
        {{ service.title }}
      </router-link>
      <div
        v-for="(item, index) in service.what_we_do"
        :key="index"
        class="service-description-small"
      >
        {{ item }}
      </div>
      <router-link
        class="learn-more link"
        :to="{ name: 'ServiceDetail', params: { slug: service.slug }}"
      >
        Learn more
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
}
</script>
